import request from "../config/axios-config";

export function sendAction(action, actionData) {
    return request({
        url: "/user-action",
        method: 'post',
        data: {
            action: action,
            actionData: actionData
        }
    }).then(json => {

    }).catch(err => {

    })
}